import { getSafeLocale } from './locale.service';
import { LOCALE_SEPARATOR } from './locale.constants';

interface ILocaleUtilOptions {
    language?: string;
    useUrl?: boolean;
}

/** Return language code in lower case, like "en" or "de" */
export function getShortLanguageCode(options: ILocaleUtilOptions): string {
    const { language, useUrl } =  options;

    return getSafeLocale({ language, useUrl, useBrowserFallback: true })
        .split(LOCALE_SEPARATOR)[0]
        .toLowerCase();
}

/** Return country code in upper case, like "EN" or "ES" */
export function getCountryFromLanguage(options: ILocaleUtilOptions): string {
    const { language, useUrl } =  options;

    return getSafeLocale({ language, useUrl, useBrowserFallback: true })
        .split(LOCALE_SEPARATOR)[1]
        .toUpperCase();
}
